import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

const translations: Record<string, I18nDefinition> = {
  title: {
    id: 'insurance_missed_occurrence_payment_title',
    defaultMessage: 'Update payment method',
  },
}

export default translations
